var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, Chip, TextField } from "@mui/material";
import { DataTypeOperator } from "../../../models/audience/filter.model";
import { useTranslation } from "react-i18next";
export var FilterEnumInput = function (_a) {
    var _b;
    var operator = _a.operator, filterRow = _a.filterRow, setFilterRow = _a.setFilterRow, enumValues = _a.enumValues;
    var content = null;
    var t = useTranslation().t;
    switch (operator) {
        case DataTypeOperator.IN:
        case DataTypeOperator.NOT_IN:
            content = (_jsx(Autocomplete, { size: 'small', clearIcon: false, options: enumValues, 
                /*
                    We must translate the raw option - as this is generic component used for all enums
                    And we do not know which enum is used at the moment
                    Therefore -> we need to make raw localizations (e.g. ACCOMMODATION: Accommodation)
                */
                getOptionLabel: function (option) { return option ? t(option) : t('(Not set)'); }, multiple: true, renderTags: function (value, props) {
                    return value.map(function (option, index) { return (_jsx(Chip, __assign({ size: 'small', label: option ? t(option) : option }, props({ index: index })))); });
                }, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { placeholder: t("Add Values"), hiddenLabel: true })); }, sx: { width: '100%', minWidth: 200 }, value: ((_b = filterRow.textValues) === null || _b === void 0 ? void 0 : _b.filter(function (v) { return !!v; })) || [], onChange: function (e, value) {
                    setFilterRow(__assign(__assign({}, filterRow), { textValues: value }));
                } }));
    }
    return content;
};
